













































































import { Component, Vue } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { PlayCircleIcon } from 'vue-feather-icons';
import ContactForm from '@/views/pages/help/ContactForm.vue';
import { BModal } from 'bootstrap-vue';

interface Video {
  id: string;
  title: string;
  text: string;
}

@Component({ name: 'help', components: { PlayCircleIcon, ContactForm } })
class Help extends Vue {
  videos2: Video[] = [
    {
      id: 'intro_login',
      title: 'Zielsetzung & erster LOGIN',
      text:
        'In dem ersten Erklärvideo geht es um die Idee und Zielsetzung unseres\n' +
        '              ADMIRAL-Dashboards sowie den ersten LOGIN.',
    },
    {
      id: 'settings',
      title: 'Einstellungen & Benutzerverwaltung',
      text:
        'Die aktuell verfügbaren Einstellungmöglichkeiten in Eurem Account und das Anlegen von neuen\n' +
        'Teammitgliedern. ',
    },
    {
      id: 'dashboardfull',
      title: 'Das Herzstück - was kann das Dashboard?',
      text:
        'Funktionsweise des Dashboards, Begrifflichkeiten, Anwendungsmöglichkeiten und helfe Euch bei \n' +
        'den ersten Schritten. Ziel ist es, dass Ihr das System so nutzt, dass es fester Bestandteil Eures täglichen Arbeitens wird- dann entfaltet es seine ganze Stärke!',
    },
    {
      id: 'praxisbeispiele',
      title: 'Praxisbeispiele zur täglichen Arbeit',
      text: 'Wie Ihr künftig in mit unserem Dashboard Euren Vertrieb organisieren könnt.  Dabei gebe ich 2 Praxisbeispiele und möchte Euch zeigen, wie einfach & schnell ihr Eure Geschäftsvorgänge erfasssen und immer im Blick behaltet.',
    },
    {
      id: 'hess-club-ringausschreibung',
      title: 'Heß-Club und Ringausschreibung',
      text: 'Eine kurze Erklärung zum Thema Heß-Club und Ringausschreibung mit ihren Gold-, Silber- und Bronzezielen.',
    },
  ];
  videos: Video[] = [
    {
      id: '01Willkommenstape',
      title: 'Willkommenstape',
      text:
        'In dem ersten Erklärvideo geht es um die Idee und Zielsetzung unseres\n' +
        '              ADMIRAL-Dashboards sowie den ersten LOGIN.',
    },
    {
      id: '02Vertriebscockpit',
      title: 'Vertriebscockpit',
      text:
        'In dem ersten Erklärvideo geht es um die Idee und Zielsetzung unseres\n' +
        '              ADMIRAL-Dashboards sowie den ersten LOGIN.',
    },
    {
      id: '03Anbahnungsliste',
      title: 'Anbahnungsliste',
      text:
        'In dem ersten Erklärvideo geht es um die Idee und Zielsetzung unseres\n' +
        '              ADMIRAL-Dashboards sowie den ersten LOGIN.',
    },
    {
      id: '04Anbahnung_anlegen',
      title: 'Anbahnung anlegen',
      text:
        'In dem ersten Erklärvideo geht es um die Idee und Zielsetzung unseres\n' +
        '              ADMIRAL-Dashboards sowie den ersten LOGIN.',
    },
    {
      id: '05Hashtagsystem',
      title: 'Hashtagsystem',
      text:
        'In dem ersten Erklärvideo geht es um die Idee und Zielsetzung unseres\n' +
        '              ADMIRAL-Dashboards sowie den ersten LOGIN.',
    },
    {
      id: '06Filtersystem',
      title: 'Filtersystem',
      text:
        'In dem ersten Erklärvideo geht es um die Idee und Zielsetzung unseres\n' +
        '              ADMIRAL-Dashboards sowie den ersten LOGIN.',
    },
    {
      id: '07Wiedervorlage',
      title: 'Wiedervorlage',
      text:
        'In dem ersten Erklärvideo geht es um die Idee und Zielsetzung unseres\n' +
        '              ADMIRAL-Dashboards sowie den ersten LOGIN.',
    },
    {
      id: '08Aufgabenbereich',
      title: 'Aufgabenbereich',
      text:
        'In dem ersten Erklärvideo geht es um die Idee und Zielsetzung unseres\n' +
        '              ADMIRAL-Dashboards sowie den ersten LOGIN.',
    },
    {
      id: '09Einstellungen',
      title: 'Einstellungen',
      text:
        'In dem ersten Erklärvideo geht es um die Idee und Zielsetzung unseres\n' +
        '              ADMIRAL-Dashboards sowie den ersten LOGIN.',
    },
    {
      id: '10Mailbenachrichtigungen',
      title: 'Mailbenachrichtigungen',
      text:
        'In dem ersten Erklärvideo geht es um die Idee und Zielsetzung unseres\n' +
        '              ADMIRAL-Dashboards sowie den ersten LOGIN.',
    },
    {
      id: '11Backoffice_Aufgaben',
      title: 'Backoffice Aufgaben',
      text:
        'In dem ersten Erklärvideo geht es um die Idee und Zielsetzung unseres\n' +
        '              ADMIRAL-Dashboards sowie den ersten LOGIN.',
    },
  ];
  selectedVideo: Video | null = null;

  handlePlayVideo(videoId: string) {
    this.selectedVideo = this.videos.find((video: Video) => video.id === videoId) || null;

    (this.$refs['show-video'] as BModal).show();
    this.$nextTick(() => {
      (this.$refs['video'] as HTMLVideoElement).play();
    });
  }
}

export default Help;
